import * as React from 'react';

var _circle, _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgCoinbase = function SvgCoinbase(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 58.333,
        cy: 58.365,
        r: 41.667,
        fill: "#fff"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#1952E4",
        d: "M54.674.031h11.361c11.362 1.42 21.302 4.97 30.533 12.071 11.361 8.521 19.172 19.882 22.012 34.083.71 2.84 1.42 5.68 1.42 8.521v12.07c-1.42 11.362-4.971 21.303-12.071 29.823-8.52 11.361-19.882 19.172-34.083 22.012-2.84.711-5.68 1.42-8.52 1.42H53.963c-11.36-1.42-21.301-4.97-30.532-12.07C12.07 99.44 4.26 88.079 1.42 73.877.71 71.037 0 68.197 0 65.357V53.286c1.42-10.651 4.97-20.592 12.07-29.823C20.592 12.103 32.664 4.291 46.865.741c3.136-.71 4.803-.71 7.81-.71m6.391 95.148c19.882-.71 36.213-18.461 33.373-39.053-2.13-17.752-17.752-31.953-36.213-31.243-19.882.71-36.213 18.462-33.373 39.054 2.13 17.751 17.751 31.952 36.213 31.242"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#1952E4",
        d: "M59.642 49.029h8.52c2.131 0 2.841.71 2.841 2.84v17.042c0 2.13-.71 2.84-2.84 2.84H51.12c-2.13 0-2.84-.71-2.84-2.84V51.869c0-2.13.71-2.84 2.84-2.84z"
    })));
};

export { SvgCoinbase as ReactComponent };
//# sourceMappingURL=Coinbase.svg.es.js.map
